module.exports = __webpack_public_path__ + "5af1cebe68fc7c156dbacb8c8058f89b.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/franchises/coh_mobile.jpg
// module id = 148
// module chunks = 0